<div class="text-center" [ngClass]="size" [title]="text ? 'Loading ' + text : 'Loading'">
  <div role="status">
    <svg xmlns="http://www.w3.org/2000/svg" class="loading-icon" viewBox="0 0 188 188">
      <defs>
        <style>
          .loading-icon rect {
            fill: #0fb1c5;
            stroke: #007c90;
            stroke-miterlimit: 10;
            stroke-width: 0.06px
          }

          .loading-icon2 {
            opacity: 0.9
          }

          .loading-icon3 {
            opacity: 0.8
          }

          .loading-icon4 {
            opacity: 0.7
          }

          .loading-icon5 {
            opacity: 0.6
          }

          .loading-icon6 {
            opacity: 0.5
          }
        </style>
      </defs>
      <rect class="loading-icon1" x="0" y="0" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="0" y="80.7" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="0" y="53.8" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="0" y="26.9" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="26.85" y="0" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="26.85" y="80.7" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="26.85" y="53.8" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="0" y="161.4" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="0" y="134.5" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="0" y="107.6" width="26.85" height="26.9" />
      <rect class="loading-icon2" x="53.7" y="0" width="26.85" height="26.9" />
      <rect class="loading-icon2" x="53.7" y="26.9" width="26.85" height="26.9" />
      <rect class="loading-icon2" x="53.7" y="80.7" width="26.85" height="26.9" />
      <rect class="loading-icon2" x="53.7" y="107.6" width="26.85" height="26.9" />
      <rect class="loading-icon2" x="53.7" y="134.5" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="26.85" y="161.4" width="26.85" height="26.9" />
      <rect class="loading-icon1" x="26.85" y="134.5" width="26.85" height="26.9" />
      <rect class="loading-icon5" x="134.26" y="134.5" width="26.85" height="26.9" />
      <rect class="loading-icon5" x="134.26" y="53.8" width="26.85" height="26.9" />
      <rect class="loading-icon4" x="107.41" y="161.4" width="26.85" height="26.9" />
      <rect class="loading-icon4" x="107.41" y="80.7" width="26.85" height="26.9" />
      <rect class="loading-icon4" x="107.41" y="0" width="26.85" height="26.9" />
      <rect class="loading-icon3" x="80.56" y="161.4" width="26.85" height="26.9" />
      <rect class="loading-icon3" x="80.56" y="107.6" width="26.85" height="26.9" />
      <rect class="loading-icon3" x="80.56" y="26.9" width="26.85" height="26.9" />
      <rect class="loading-icon6" x="161.11" y="80.7" width="26.85" height="26.9" />
      <rect class="loading-icon6" x="161.11" y="0" width="26.85" height="26.9" />
    </svg>
  </div>
  <h6 *ngIf="showText && text">{{ text }}&hellip;</h6>
</div>
